import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const VerifikasiEmailContent = () => {
    return (
        <Box display="flex" flexDirection="column" gap={1}>
            <Typography variant="h5" fontWeight="bold" textAlign="center">
                Cek email anda untuk verifikasi
            </Typography>
            <Typography variant="body1" color="#808080" textAlign="center">
                Silahkan verifikasi akun anda dengan cara mengklik link yang
                kami kirimkan ke email anda.
            </Typography>
        </Box>
    );
};

export default VerifikasiEmailContent;
